<template>
  <dv-charts :option="option" />
</template>

<script>
export default {
  props: {
    option: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
};
</script>

<style lang="less" scoped>
</style>